export default __webpack_public_path__ + "static/media/ZETI_Logo_White.d2078c02.png";